import cx from 'classnames';
import NextLink from 'next/link';

import {Icon, Text} from '#component/base';
import {ActionPlanAdjustmentList} from '#component/partial';

import {CTACard} from '../CTACard';

import {ActionPlanCardProps} from './ActionPlanCard.types';

import * as css from './ActionPlanCard.css';

export const ActionPlanCard = ({
  adjustments,
  className,
  columnSpan,
  ...otherProps
}: ActionPlanCardProps) => {
  const hasActionPlan = Array.isArray(adjustments) && adjustments.length > 0;

  return hasActionPlan ? (
    <div className={cx(className, css.root)}>
      <NextLink href="/actionplan" passHref>
        <a {...otherProps}>
          <Text as="h3" className={css.title} variant="heading3" color="burgundy">
            <Icon name="ClipboardText" color="burgundy" size="large" weight="regular" />
            Your Action Plan
          </Text>

          <ActionPlanAdjustmentList adjustments={adjustments} variant="inline" />

          <Text as="p" className={css.viewActionPlanButton} color="eggplantDark" variant="button">
            View Action Plan
            <Icon color="burgundy" name="ArrowRight" size="small" />
          </Text>
        </a>
      </NextLink>
    </div>
  ) : (
    <CTACard
      columnSpan={columnSpan}
      headline="Get your Action Plan"
      href="/actionplan"
      imageUrl="/image/action-plan.jpg"
      lede="Get a personalized, actionable checklist of lifestyle changes to improve your TallyAge™ and live better, longer."
      fadeImage={false}
      btnColor="primary-dark"
    />
  );
};
